export default [
  {
    path: '/practice/game',
    name: 'practiceGame',
    component: () => import('@/views/Room/GameRoom.vue'),
    props: {mode: 'practiceGame'},
    meta: {
      hasNavigation: false,
      fromUpperTransitionType: 'passAnimation',
      toUpperTransitionType: 'slide',
      passAnimationMode: 'game',
      requireAuth: true,
      chessboardRoom: true,
    },
  },
  {
    path: '/practice/tsume/ranks/:rank/types/:type',
    name: 'practiceTsume',
    component: () => import('@/views/Room/TsumeRoom.vue'),
    meta: {
      hasNavigation: false,
      fromUpperTransitionType: 'passAnimation',
      toUpperTransitionType: 'slide',
      passAnimationMode: 'tsume',
      requireAuth: true,
      chessboardRoom: true,
    },
  },
];
